// format.ts — prezentacja liczb. Jedyne miejsce, w którym grosze zamieniają się na złote.
//
// Grosze są liczbami całkowitymi przez całą drogę od bazy. Zamiana na złote jest ostatnią
// operacją przed wyświetleniem — nigdy przed sumowaniem, nigdy przed porównaniem.

const PLN = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const INT = new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 0 });

export function formatGrosze(grosze: number | null | undefined): string {
  if (grosze === null || grosze === undefined || !Number.isFinite(grosze)) return '—';
  return PLN.format(grosze / 100);
}

export function formatCount(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return INT.format(value);
}

/** Zmiana procentowa ze znakiem. `null` znaczy „nie da się policzyć”, a nie „0%”. */
export function formatDelta(pct: number | null | undefined): string {
  if (pct === null || pct === undefined || !Number.isFinite(pct)) return '—';
  const sign = pct > 0 ? '+' : '';
  return `${sign}${pct.toLocaleString('pl-PL', { maximumFractionDigits: 1 })}%`;
}

export function formatRatio(ratio: number | null | undefined): string {
  if (ratio === null || ratio === undefined || !Number.isFinite(ratio)) return '—';
  return `${Math.round(ratio * 100)}%`;
}

/** Zakres dat w formacie, który da się przeczytać na głos. */
export function formatRange(from: string, to: string): string {
  return from === to ? from : `${from} → ${to}`;
}

/** Domyślne okno analizy: ostatnie 30 dni licząc wstecz od dziś (czas warszawski). */
export function defaultRange(today = new Date()): { date_from: string; date_to: string } {
  const iso = (d: Date) => d.toLocaleDateString('en-CA', { timeZone: 'Europe/Warsaw' });
  const to = iso(today);
  const from = iso(new Date(today.getTime() - 29 * 86400000));
  return { date_from: from, date_to: to };
}
